import { APIError } from '../../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../../useAPIProvider';

export const useReservedStock = (mspId: string, customerId: string) => {
  return useAPIQuery(['getReservedStockLevels', mspId, customerId], async client => {
    const response = await client.reservedStock.getStockLevels({ params: { mspId, customerId } });
    if (response.status !== 200) throw APIError.fromResponse(response);

    return response.body.items;
  });
};

interface UpsertReservedStockArgs {
  daasCatalogItemId: string;
  stockLevel: number;
}

export const useUpsertReservedStock = (mspId: string, customerId: string) => {
  return useAPIMutation((client, query) => {
    return async (stock: UpsertReservedStockArgs[]) => {
      const response = await client.reservedStock.updateStockLevel({
        body: stock,
        params: {
          mspId,
          customerId
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      await query.invalidateQueries(['getReservedStockLevels', mspId, customerId]);

      return response.body;
    };
  });
};
